import { CaseInsensitiveMap3bv985x2xrppt as CaseInsensitiveMap } from './CaseInsensitiveMap.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function caseInsensitiveMap() {
  return new (CaseInsensitiveMap())();
}
//region block: exports
export {
  caseInsensitiveMap as caseInsensitiveMap1xhpwzg797p51,
};
//endregion

//# sourceMappingURL=Collections.mjs.map
